export const getLinkFromKey = (key: string) => {
  return `${
    process.env.REACT_APP_SITE_URL ?? "https://forum-trium.com/"
  }signup/${key}`;
};

export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
